import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "1px solid #999",
  borderRadius: "20px",
  boxShadow: 24,
  width: "400px",
  height: "270px",
  p: 4,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
};

const actionButton = {
  display: "inline-block",
  width: "150px",
  padding: "8px 8px",
  border: "1px solid #F475A4",
  borderRadius: "8px",
  color: "#fff",
  fontSize: "14px",
  textAlign: "center",
  textDecoration: "none",
  backgroundColor: "#F475A4",
  "&:hover": {
    backgroundColor: "#e0669b",
  },
  margin: "0 auto",
};

interface CompleteProfileModalProps {
  open: boolean;
  onClose?: () => void;
  message?: string;
}

export default function CompleteProfileModal({
  open,
  onClose,
  message = "Please complete your profile to continue.",
}: CompleteProfileModalProps) {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate("/dashboard/myAccount");
    if (onClose) onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="complete-profile-modal"
      aria-describedby="complete-profile-modal-description"
    >
      <Box sx={style}>
        <Typography
          variant="h6"
          component="h2"
          sx={{
            mb: 3,
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          Profile Incomplete
        </Typography>
        
        <Typography
          sx={{ 
            mb: 5, 
            textAlign: "center", 
            fontSize: "16px",
            color: "#555"
          }}
        >
          {message}
        </Typography>

        <Button
          sx={actionButton}
          onClick={handleRedirect}
        >
          Complete Profile
        </Button>
      </Box>
    </Modal>
  );
}